import React, { useState, useEffect, useRef } from "react";
import classNames from "../../classNames";

let timeout;

function NavBarSearch({ className, onSubmit, dropdownOptions, ...option }) {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [inputValue, setInputValue] = useState(
    // sessionStorage.getItem("searchValue") ||
    ""
  );
  const inputRef = useRef(null);
  const dropdownRef = useRef(null);

  function onChange(value) {
    clearTimeout(timeout);
    setInputValue(value);
    // sessionStorage.setItem("searchValue", value);
    timeout = setTimeout(() => {}, 300);

    const filtered = dropdownOptions.filter((option) =>
      option.employeeName.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredOptions(filtered);
    setDropdownVisible(true);
  }

  function onOptionSelect(option) {
    setInputValue(option.employeeName); // Set selected option to input value
    // sessionStorage.setItem("searchValue", option.employeeName);
    onSubmit(option.id);
    setDropdownVisible(false);
  }

  function handleClickOutside(event) {
    if (
      inputRef.current &&
      dropdownRef.current &&
      !inputRef.current.contains(event.target) &&
      !dropdownRef.current.contains(event.target)
    ) {
      setDropdownVisible(false);
    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className={classNames("input-group", className)}
      style={{ position: "relative" }}
    >
      <i
        className="bi bi-search position-absolute"
        style={{
          zIndex: 4,
          width: "50px",
          height: "50px",
          lineHeight: "40px",
          textAlign: "center",
        }}
      />
      <input
        ref={inputRef}
        {...option}
        onChange={(e) => onChange(e.target.value)}
        type="search"
        className="form-control rounded ps-5"
        placeholder="Search"
        value={inputValue} // Bind input value to state
        // style={{ width: "100px" }}
      />
      {dropdownVisible && (
        <ul
          ref={dropdownRef}
          className="dropdown-menu show"
          style={{
            maxHeight: "20rem",
            overflow: "auto",
            position: "absolute",
            top: "100%",
            left: 0,
            zIndex: 1050,
            width: "100%",
          }}
        >
          {filteredOptions.map((option, index) => (
            <li
              key={index}
              onClick={() => onOptionSelect(option)}
              className="dropdown-item"
              style={{ cursor: "pointer" }}
            >
              {option.profile ? (
                <img
                  src={option.profile}
                  width={25}
                  height={25}
                  className="rounded-circle"
                  alt="Profile"
                />
              ) : (
                <span
                  className="bg-primary p-1 text-white fs-sm"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "25px", // Adjust the width and height as needed
                    height: "25px",
                    borderRadius: "50%",
                  }}
                >
                  {option.employeeName.substring(0, 2).toUpperCase()}
                </span>
              )}{" "}
              {option.employeeName}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default NavBarSearch;
